'use client';
import CartIconButton from '@repo/ui/src/components/CartIconButton';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import useBasket from '@hooks/basket/useBasket';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';

const NavbarShoppingCart = () => {
  const { eCommEnabled } = useCurrentUrl();
  const { data: basket } = useBasket();
  const { push } = useModal(ModalID.cart);

  if (!eCommEnabled || !basket) {
    return null;
  }

  return <CartIconButton count={basket.totalItems ?? 0} onClick={push} />;
};

export default NavbarShoppingCart;
